import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SignalRService } from './signalr.service';
import { DeviceCheckinStateService } from './broadcasters/checkin.state.service';
import { SignalRCoreService } from './signalr-core.service';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
    ],
    providers: [
        { provide: DeviceCheckinStateService, useClass: DeviceCheckinStateService },
        { provide: SignalRService, useClass: SignalRService },
        { provide: SignalRCoreService, useClass: SignalRCoreService }
    ]
})


export class SignalRModule {
}
